import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

/**
 * @param {Object} props
 * @param {"md"|"sm"} [props.size='md'] - The size of the text.
 * @param {"default"|"muted"} [props.variant='default'] - The variant of the text.
 * @param {import('utils/types').Weight} [props.weight='normal'] - The weight of the text.
 * @param {string} [props.className=''] - Additional class names for styling.
 * @param {React.ReactNode} props.children - The content to display inside the cell.
 */
export default function TableCellText({
  size = 'md',
  variant = 'default',
  weight = 'normal',
  className = '',
  children = null
}) {
  if (!children) return null;

  return (
    <div
      data-size={size}
      data-variant={variant}
      data-weight={weight}
      className={cn(styles.text, className)}
    >
      {children}
    </div>
  );
}
